/* =============================================================================
   POPUP DOS 10% — o comportamento.

   ⛔ ESTE POPUP NASCE DESLIGADO e assim fica até o Silva o ligar no editor do
   tema. Enquanto a Nortada não entregar o código de desconto, quem trabalha é o
   popup do Klaviyo: um nosso que promete 10% e não cumpre é pior do que nenhum.

   ⚠️ Para o ver sem o ligar a toda a gente: junta `?ver-popup=1` ao endereço.
   Nesse modo ele aparece sempre e NÃO guarda nada, para se poder repetir.
   ========================================================================== */
(function () {
  'use strict';
  var raiz = document.getElementById('ilhaPopup');
  if (!raiz) return;

  var CHAVE = 'ilha_popup_10';
  var PORTA = 'https://contas.ilhadoscosmeticos.pt/subscrever';
  var ensaio = /[?&]ver-popup=1/.test(location.search);

  var caixa = raiz.querySelector('.ilha-pop__caixa'),
      fechar = document.getElementById('ilhaPopupX'),
      /* ⚠️ A saída honesta, por baixo do formulário. Quem não a encontra fecha a
         PÁGINA em vez de fechar o popup, e isso perde a visita toda. */
      recusar = document.getElementById('ilhaPopupNao'),
      campo = document.getElementById('ilhaPopupEmail'),
      botao = document.getElementById('ilhaPopupBt'),
      aviso = document.getElementById('ilhaPopupMsg'),
      textoLegal = document.getElementById('ilhaPopupTexto'),
      formulario = document.getElementById('ilhaPopupForm'),
      rotulo = botao ? (botao.textContent || '').trim() : '';

  /* ⚠️ Tudo o que toca no armazenamento vai em try/catch. Numa janela privada, ou
     com os dados do site bloqueados, ler isto ATIRA — e sem isto o popup deixava
     de aparecer a quem tem o browser assim, sem erro visível nenhum. */
  function lido(onde, chave) {
    try { return window[onde].getItem(chave); } catch (e) { return null; }
  }
  function guardar(onde, chave, valor) {
    try { window[onde].setItem(chave, valor); } catch (e) { /* sem memória, paciência */ }
  }

  function jaChega() {
    if (ensaio) return false;
    if (lido('localStorage', CHAVE)) return true;      // já se inscreveu ou já o fechou
    if (lido('sessionStorage', CHAVE + '_visto')) return true;  // já apareceu nesta visita
    return false;
  }

  function dizer(txt, bem) {
    if (!aviso) return;
    aviso.textContent = txt;
    aviso.hidden = false;
    aviso.className = 'ilha-pop__msg ' + (bem ? 'ok' : 'err');
  }

  /* 09/10/2026 · POPUP 5.0 (o «Anel», escolhido pelo Silva). A letra é a Poppins do tema, que já cá está: acabou
     a espera pela serifada. ⛔ E nunca por cima de uma gaveta aberta (carrinho, menu, vista rápida): visto no ar a
     09/10, o popup abria em cima da gaveta do carrinho numa visita nova. Espera e tenta outra vez. */
  /* 11/10/2026 · ⛔ Também nunca com o ecrã da PESQUISA aberto (o Sonar põe `data-sonar-aberto` no <html>) nem com
     a cliente a escrever num campo: o `caixa.focus()` roubava o foco e as teclas seguintes iam parar ao popup
     (medido pelo Sonar: o campo ficou com «lola rapunzel» em vez de «shampoo»). */
  /* Só campos de ESCREVER: um clique num filtro (checkbox) ou numa cor (radio) deixa-os com foco no Chrome e não
     é escrita (as duas auditorias de 11/10). */
  var DE_ESCREVER = /^(text|search|email|tel|url|number|password|date|datetime-local|month|time|week)$/;
  function ocupada() {
    var a = document.activeElement;
    return document.body.classList.contains('modal-show') ||
      document.documentElement.hasAttribute('data-sonar-aberto') ||
      !!(a && ((a.tagName === 'INPUT' && DE_ESCREVER.test(a.type)) || a.tagName === 'TEXTAREA' || a.isContentEditable));
  }
  function abrir() {
    if (ocupada()) { setTimeout(abrir, 4000); return; }
    abrirMesmo();
  }
  function abrirMesmo() {
    /* ⚠️ Tirar o `hidden` CHEGA para ele aparecer — a entrada é uma animação do
       CSS. Já dependeu de um `requestAnimationFrame`, que não corre com o
       separador em segundo plano: o popup ficava invisível e a tapar a página. */
    raiz.hidden = false;
    /* ⚠️ Em modo de ensaio não se guarda NADA, nem a marca da sessão. Guardava, e
       isso fazia com que a segunda vez no mesmo separador já não aparecesse —
       enganava quem estivesse a experimentá-lo. */
    if (!ensaio) guardar('sessionStorage', CHAVE + '_visto', '1');
    /* ⚠️ O foco vai para a CAIXA, não para o campo: no telemóvel o campo abria o teclado logo, que tapava o anel a
       desenhar-se e empurrava o cartão. O leitor de ecrã anuncia o diálogo na mesma. */
    if (caixa) { try { caixa.focus({ preventScroll: true }); } catch (e) {} }
    document.addEventListener('keydown', teclaEscape);
  }

  function sair(porque) {
    raiz.classList.add('a-fechar');
    document.removeEventListener('keydown', teclaEscape);
    setTimeout(function () { raiz.hidden = true; raiz.classList.remove('a-fechar'); }, 220);
    /* ⚠️ Um popup que volta a quem já disse que não é a maneira mais rápida de a
       pessoa deixar de voltar ao site. Por isso o "não" guarda-se para sempre. */
    if (!ensaio) guardar('localStorage', CHAVE, porque || 'fechado');
  }

  function teclaEscape(ev) { if (ev.key === 'Escape') sair('fechado'); }

  function enviar() {
    var mail = (campo.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { dizer('O email não está completo.', false); campo.focus(); return; }
    botao.disabled = true; botao.textContent = 'A enviar…';
    fetch(PORTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: mail,
        origem: 'popup',
        /* ⚠️ A prova sai do ECRÃ, não do código: é a frase que ela mesma leu.
           Se alguém mudar o texto no popup, a prova muda com ele. */
        texto: textoLegal ? (textoLegal.textContent || '').trim() : ''
      })
    }).then(function (r) {
      if (r.status === 201 || r.status === 200) {
        /* ⛔ SEMPRE A MESMA MENSAGEM, e a razão é séria: há pessoas que já
           cancelaram connosco e essas não voltam a entrar nem levam desconto,
           mas o servidor responde 201 na mesma, de propósito. Se aqui
           mostrássemos algo diferente, qualquer um descobria quem está na nossa
           lista, um endereço de cada vez. */
        if (formulario) formulario.hidden = true;
        dizer('Está quase. Falta confirmar no email que acabámos de enviar.', true);
        if (!ensaio) guardar('localStorage', CHAVE, 'subscrito');
        setTimeout(function () { sair('subscrito'); }, 3200);
        return;
      }
      botao.disabled = false; botao.textContent = rotulo;
      if (r.status === 429) { dizer('Já recebemos este pedido há pouco. Daqui a uns minutos já dá.', false); return; }
      dizer('Não foi possível inscrever agora. Daqui a pouco já deve dar.', false);
    }).catch(function () {
      botao.disabled = false; botao.textContent = rotulo;
      dizer('Não foi possível inscrever agora. Daqui a pouco já deve dar.', false);
    });
  }

  if (fechar) fechar.addEventListener('click', function () { sair('fechado'); });
  /* ⚠️ "Não preciso de desconto" fecha como o X, e é DE PROPÓSITO que fecha da mesma
     maneira: quem recusa não deve voltar a ver o popup a cada página. */
  if (recusar) recusar.addEventListener('click', function () { sair('recusado'); });
  /* clicar no escuro à volta também fecha, como o do Klaviyo faz */
  raiz.addEventListener('click', function (ev) { if (ev.target === raiz) sair('fechado'); });
  if (botao) botao.addEventListener('click', enviar);
  if (campo) campo.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter') { ev.preventDefault(); enviar(); }
  });

  if (jaChega()) return;
  var espera = parseInt(raiz.getAttribute('data-espera'), 10);
  if (isNaN(espera) || espera < 0) espera = 8;
  setTimeout(abrir, ensaio ? 300 : espera * 1000);
})();
